"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineFilled = defineFilled;
exports.definePlaceholderColor = definePlaceholderColor;
exports.useFilledState = useFilledState;
exports.useFieldMouseDown = useFieldMouseDown;
const react_1 = require("react");
const colors_1 = require("../colors");
/**
 * Получив значения value и defaultValue для поля, определяет является ли оно заполненным.
 * @param value Значение value.
 * @param defaultValue Значение defaultValue.
 * @return Является ли поле заполненным.
 */
function defineFilled(value, defaultValue) {
    return [value, defaultValue].some(v => typeof v !== 'undefined' && `${v}` !== '');
}
/**
 * Получи информацию о состоянии поля возвращает цвет placeholder.
 * @param state Состояние.
 * @return Цвет.
 */
function definePlaceholderColor({ failed, disabled, }) {
    let placeholderColor = undefined;
    switch (true) {
        case failed:
            placeholderColor = colors_1.COLORS.get('additional-deep-red');
            break;
        case disabled:
            placeholderColor = colors_1.COLORS.get('basic-gray24');
            break;
        case !disabled:
            placeholderColor = colors_1.COLORS.get('basic-gray38');
            break;
    }
    return placeholderColor;
}
/**
 * Хук состояния заполненности поля текстовым значением.
 * @param ref Ref элемента поля.
 * @param affectProps Свойства, влияющие на состояние заполненности.
 * @return Кортеж: состояние; функция обновления состояния.
 */
function useFilledState(ref, { value, defaultValue, }) {
    const [filled, setFilled] = (0, react_1.useState)(() => defineFilled(value, defaultValue));
    const updateFilled = (0, react_1.useCallback)(event => {
        setFilled(Boolean(event.currentTarget.value));
    }, []);
    (0, react_1.useEffect)(() => {
        setFilled(Boolean(ref.current?.value));
    });
    return [filled, updateFilled];
}
/**
 * Хук, формирующий callback события mousedown на блоке поля, фокусирующий пользователя на поле.
 * @param fieldRef Ref элемента поля.
 * @param callback Будет вызвана по событию mousedown.
 * @return Функция обратного вызова.
 */
function useFieldMouseDown(fieldRef, callback) {
    return (0, react_1.useCallback)(event => {
        const field = fieldRef.current;
        callback?.(event);
        if (!event.defaultPrevented && field && event.target !== field) {
            event.preventDefault();
            field.focus();
        }
    }, [fieldRef, callback]);
}
//# sourceMappingURL=utils.js.map